<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.IntervenorRequest.casePartyRole">
      <v-row>
        <v-col cols="4">
          <naj-input
            :type-id="formFieldType.radioButton"
            :label="local.caseRelatedRequest.IntervenorRequest.casePartyRole"
            :value.sync="formModel.casePartyRole"
            :items="casePartyRole"
            item-value="id"
            item-text="name"
            validates="required"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <national-address-form
      v-if="isResidence && !isOrganization"
      :form-model="formModel.nationalAddress"
      :national-addresses="formModel.nationalAddresses"
      :required="isResidence"
      :is-view-mode="isViewMode"
    >
    </national-address-form>

    <naj-address
      v-if="formModel.socialIdType && !isResidence && !isOrganization"
      :title="local.titleHeader.residenceAddress"
      :form-model="formModel.residenceAddress"
      :required="!isResidence"
      :is-view-mode="isViewMode"
    >
    </naj-address>

    <profession-form
      v-if="!isOrganization"
      :form-model="formModel"
      :required="true"
      :is-view-mode="isViewMode"
    ></profession-form>

    <contact-form
      v-if="!isOrganization"
      :form-model="formModel.contact"
      :required="true"
      :mobile-required="true"
      :is-view-mode="isViewMode"
    ></contact-form>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, socialIdTypeEnum, partyTypeEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapLUTActions, mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
import NationalAddressForm from '../../../../../modules/lawsuit/components/step1/party-types/forms/national-address-form';
import ProfessionForm from '../../../../../modules/lawsuit/components/step1/party-types/forms/profession-form';
import ContactForm from '../../../../../modules/lawsuit/components/step1/party-types/forms/contact-form';

export default {
  name: 'IntervenorRequest',
  inject: ['$validator'],
  components: {
    NationalAddressForm,
    ProfessionForm,
    ContactForm,
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapLUTState(['casePartyRole', 'countries', 'sex']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
      isGovernmentalUser() {
         return this.userInfo.loginType == 'governmental';
    },
      isOrganization() {
        return this.userInfo.isOrganizationUser;
    },
    isResidence() {
      return (
        this.formModel.socialIdType === socialIdentityTypeEnum.nationalId ||
        this.formModel.socialIdType === socialIdentityTypeEnum.regularResidency
      );
    },
  },
  watch: {},
  mounted() {
    if (this.formModel) {
      this.readCurrentUserInfo();
    }
  },
  created() {
    this.$set(this.formModel, 'contact', (this.formModel.contact || {}));
    this.$set(this.formModel, 'nationalAddress', (this.formModel.nationalAddress || {}));
    this.$set(this.formModel, 'residenceAddress', (this.formModel.residenceAddress || {}));
  },
  methods: {
    ...mapLUTActions([
      'getCountries',
    ]),
      readCurrentUserInfo() {
          if (this.userInfo) {
              if (this.userInfo.isOrganizationUser) {
                  const socialTypeId = socialIdentityTypeEnum.unifiedNumber;
                  this.$set(this.formModel, 'partyType', this.isGovernmentalUser ? partyTypeEnum.government : partyTypeEnum.firm);
                  this.$set(this.formModel, 'socialId', this.userInfo.nationalRecordNumber);  
                this.$set(this.formModel, 'socialIdType', socialTypeId);
                this.$set(this.formModel, 'unifiedNumber', this.userInfo.nationalRecordNumber);
                this.$set(this.formModel, 'organizationName', this.userInfo.fullName);
                this.$set(this.formModel, 'name', this.userInfo.fullName);
                this.$set(this.formModel, 'socialIdTypeName', socialIdTypeEnum[socialTypeId]);
                this.$set(this.formModel, 'shouldEncryptFields', 0);
            }
            else {
                const socialTypeId = this.userInfo.socialIdType;
                const dateOfBirth = this.userInfo.dateOfBirth && this.userInfo.dateOfBirth.split('T')[0];
                this.$set(this.formModel, 'socialIdType', socialTypeId);
                this.$set(this.formModel, 'socialId', this.userInfo.socialId);
                this.$set(this.formModel, 'firstName', this.userInfo.firstName);
                this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
                this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
                this.$set(this.formModel, 'familyName', this.userInfo.familyName);
                this.$set(this.formModel, 'dateOfBirth', dateOfBirth);
                this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
                this.$set(this.formModel, 'sex', this.userInfo.gender);
                this.$set(this.formModel, 'isRetrievedFromMoi', true);
                this.$set(this.formModel, 'socialIdTypeName', socialIdTypeEnum[socialTypeId]);
                this.$set(this.formModel, 'sexName', this.sex.find(a => a.id == this.userInfo.gender).name);
                this.getCountries().then((data) => {
                    const nationalityCountryName = ((data || []).find(a => a.id == this.userInfo.nationalityCountryId) || {}).name;
                    this.$set(this.formModel, 'nationalityCountryName', nationalityCountryName);
                });
                this.$set(this.formModel, 'partyType', partyTypeEnum.person);
            }
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
      }
    },
  },
};
</script>
